export default __webpack_public_path__ + "static/media/PissaroTransfer1.f4e2eecc.png";